import React from 'react'
import {connect} from 'react-redux'

import Component from '../components/reservation'
import actions from '../actions/reservation'
import orchestratorActions from '../actions/orchestrator'
import deliveryActions from '../actions/delivery'

class Container extends React.Component {
  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {}
}

const mapStateToProps = state => {
  const data = state.ui.rent.reservation
  const startData = state.ui.rent.start
  return {
    isLoading: data.get('isLoading') || startData.get('loading').size > 0,
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setRange: (start, end) => dispatch(actions.setRange(start, end)),
    saveAddItem: () => {
      dispatch(actions.saveAddItem())
        .then(range => {
          dispatch(orchestratorActions.nextStepFromReservation())
          dispatch(deliveryActions.selectDate(range.startDate))
        }, () => {})
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/rent/containers/reservation.js